import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=31cb3f9e&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"
import style0 from "#/styles/views/HomePage/HomePage.less?vue&type=style&index=0&id=31cb3f9e&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cb3f9e",
  null
  
)

export default component.exports